import { ChurnZeroEventName } from 'api/Api.generated';
import React, { useCallback } from 'react';
import { FooterWrapper, FooterLink, TinyFooterLink, P, TinyP } from 'styles';

interface BPAUFooterProps {
  helpPhone: string;
  helpEmail: string;
  wide?: boolean;
  sendEvent?: (eventName: ChurnZeroEventName, token: string | null) => void;
}

export const BPAUFooter: React.FC<BPAUFooterProps> = ({
  helpPhone,
  helpEmail,
  wide = false,
  sendEvent = () => {},
}) => {
    const onClick = useCallback(() => {
        sendEvent(ChurnZeroEventName.AlfiepayCallSupport, null);
    }, [sendEvent]);

  return (
    <FooterWrapper wide={wide}>
      <P>
        Got a question about your event or the details provided? The friendly bp Customer Care team
        at{' '}
        <FooterLink
          onClick={onClick}
          href={`tel:${helpPhone.replace(/\s/g, '')}`}
        >
          {helpPhone}
        </FooterLink>{' '}
        or{' '}
        <FooterLink
          onClick={onClick}
          href={`mailto:${helpEmail}`}
        >
          {helpEmail}
        </FooterLink>{' '}
        can help you directly with that.
      </P>
      <P>
        If you have any questions or experience issues during the payment process, our Alfiepay
        Support Team is happy to help – just drop us a message at{' '}
        <FooterLink
          onClick={onClick}
          href="mailto:support@alfiepay.com"
        >
          support@alfiepay.com
        </FooterLink>
      </P>
      <TinyP>
        BP Australia Pty Limited (ABN 53 004 085 616) and its related entities in Australia ('BP' or
        'we') collect your personal information when you are involved in an unpaid retail or fuel
        event (the 'event'). If we do not collect this information, we may not be able to notify you
        for prompt payment to resolve this event. We collect your personal information for the
        purpose facilitating event payment. We may disclose your personal details with third party
        service providers for the purposes of reporting events. We may share your personal
        information with our related body corporate entities overseas, who assist us in delivering
        our products and services. For detailed information on how BP handles personal information,
        please refer to our{' '}
        <TinyFooterLink
          href="https://www.bp.com/en_au/australia/home/privacy.html"
          target="_blank"
          rel="noopener noreferrer"
        >
          Privacy Statement
        </TinyFooterLink>
        . Should you have any privacy-related questions, please reach out to us at{' '}
        <TinyFooterLink
          onClick={onClick}
          href="mailto:privacyofficer@bp.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          privacyofficer@bp.com
        </TinyFooterLink>
        , additional contact information is provided within the Privacy Statement for your
        convenience.
      </TinyP>
    </FooterWrapper>
  );
};
